




















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { ILoginCredentials } from '@/features/account/api/auth.interfaces';

@Component({
  name: 'navbar',
})
export default class Navbar extends Vue {
  user: ILoginCredentials = {} as ILoginCredentials;

  // Getters
  @Getter('auth/isAuthenticated')
  isLoggedIn: boolean;
  @Getter('auth/isAdmin')
  isAdmin: boolean;
  @Getter('auth/userName')
  userName: string;

  handleLogout(event: any) {
    var self = this;
    this.$store.dispatch('auth/logout').then(function() {
      self.$store.dispatch('reset');
      self.$router.push('/');
    });
  }
}
